import { useState, useEffect } from 'react';

const AFFILIATE_STORAGE_KEY = 'Veraz_affiliate';

interface StoredAffiliateData {
  affiliateId: string;
  affiliateCode: string;
  name?: string; // We might not have this initially, but good to have in type
  timestamp: number;
}

export const useAffiliate = () => {
  const [affiliate, setAffiliate] = useState<StoredAffiliateData | null>(null);

  useEffect(() => {
    const loadAffiliate = () => {
      const stored = localStorage.getItem(AFFILIATE_STORAGE_KEY);
      if (stored) {
        try {
          const data = JSON.parse(stored);
          setAffiliate(data);
        } catch (e) {
          setAffiliate(null);
        }
      } else {
        setAffiliate(null);
      }
    };

    // Load initially
    loadAffiliate();

    // Listen for custom event
    const handleUpdate = () => loadAffiliate();
    window.addEventListener('affiliate-update', handleUpdate);

    // Listen for storage events (tabs sync)
    window.addEventListener('storage', loadAffiliate);

    return () => {
      window.removeEventListener('affiliate-update', handleUpdate);
      window.removeEventListener('storage', loadAffiliate);
    };
  }, []);

  return affiliate;
};
